<template>
    <b-overlay :show="submitting" rounded="sm">
    <b-modal v-model="modalVisible" hide-footer header-class="p-0" content-class="custom-model-wrap" size="lg">
        <template #modal-title="{ cancel }">
            <div class="title-block text-center p-2">
                {{ `${$translate('import')} ${subject}` }}
            </div>
            <div class="close-btn" @click="cancel()">x</div>
        </template>
        <b-card no-body>
            <b-tabs card align="center">
                <b-tab :title="`${$translate('upload')} ${subject}`" active>
                    <b-card-body v-show="!importList.length">
                        <b-row>
                            <b-col>
                                <div class="mb-4">{{ `Import ${subject}` }}</div>
                            </b-col>
                            <b-col>
                                <a href="javascript:void(0)" class="decoration-off text-success" @click="exportSampleFile"><i class="fas fa-file-excel fa-lg me-2"></i>{{$translate('download_empty_csv_template_here')}}</a>
                            </b-col>
                        </b-row>
                        <simple-csv-import v-model="importList" :placeHolderText="$translate('assets_drop_file')"
                            :startRowNo="configurationSettings.rowno" :columnsMap="columnsMap">
                        </simple-csv-import>
                    </b-card-body>

                    <b-card-body v-show="importList.length > 0">
                        <b-container>
                            <b-row>
                                <b-col cols="3">
                                    <strong>{{ `Total ${subject}` }}:</strong>
                                </b-col>
                                <b-col cols="3">
                                    {{ importList.length }}
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col cols="3"><strong> {{ $translate('status') }}: </strong></b-col>
                                <b-col cols="3"> {{ $translate('ready_to_upload') }} </b-col>
                            </b-row>

                            <b-row>
                                <b-col class="my-2">
                                    <div class="d-flex gap-2">
                                        <b-button v-show="importList.length > 0" @click="uploadData" variant="info"
                                            :disabled="submitting">
                                            <span>{{
                                                submitting
                                                ? $translate('uploading')
                                                : $translate('upload')
                                            }}</span>
                                        </b-button>
                                        <b-button v-show="importList.length > 0" @click="cancel()" variant="info">
                                            {{ $translate('cancel') }}
                                        </b-button>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-table :items="statusList" responsive :per-page="perPage" :current-page="currentPage"
                                :fields="tableFields">
                                <template #cell(status)="data">
                                    <!-- {{ data }} -->
                                    <b-badge :id="`upload-badge-${data.index}`" :variant="data.value | filterStatusVariant
                                        ">{{ $translate(data.value) }}</b-badge>
                                    <!-- Show tooltip if there are errors -->
                                    <b-tooltip v-if="data.item.error_list.length > 0" :target="`upload-badge-${data.index}`"
                                        triggers="hover">
                                        {{ $translate('errors') }}
                                        <!-- loop through the list of errors and display each -->
                                        <ul v-for="error_set in data.item
                                            .error_list" :key="error_set.index">
                                            <li v-for="error in error_set[1]" :key="`error-${error}`">
                                                {{ $translate(error) }}
                                            </li>
                                        </ul>
                                    </b-tooltip>
                                </template>
                            </b-table>
                            <b-pagination class="mt-4" v-model="currentPage" :total-rows="statusList.length"
                                :next-text="$translate('next')" :prev-text="$translate('previous')" :per-page="perPage"
                                aria-controls="my-table" align="center"></b-pagination>
                        </b-container>
                    </b-card-body>
                </b-tab>
                <b-tab :title="$translate('settings')">
                    <b-card-body>
                        <upload-data-settings @input="updateConfiguration" :subject="subject" ref="uploadDataSettings" :value="configurationSettings"
                            :data-fields="fields"></upload-data-settings>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-modal>
    </b-overlay>
</template>

<script>
import SimpleCsvImport from '@/components/SimpleCsvImport'
import UploadDataSettings from '@/components/UploadDataSettings'
import { capitalCase } from 'change-case'
import popupMixins from '@/mixins/popupMixins'
import settingsMixins from '@/mixins/settingsMixins'

/**
 * The possible statuses during upload
 */
const statuses = {
    COMPLETE: 'complete',
    ERROR: 'error_hover',
    PENDING: 'ready',
    CHECKING: 'checking',
    SAVING: 'saving',
    INVALID_LOCATION: 'invalid_location',
    GEOCODING: 'geocoding',
}

export default {
    name: 'ImportForm',
    components: { SimpleCsvImport, UploadDataSettings },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        subject: {
            type: String,
            required: true,
        },
        fields: {
            type: Array,
            required: true,
        },
        settingsKeyName: {
            type: String,
            required: true,
        },
        uploadRecord: {
            type: Function,
            required: true,
        },
    },
    mixins: [popupMixins, settingsMixins],
    data: () => {
        return {
            perPage: 15,
            currentPage: 1,
            modalVisible: false,
            importList: [],
            files: [],
            file: {},
            status: false,
            model: {},
            submitting: false,
            hasErrors: false,
            statusList: [],
        }
    },

    filters: {
        filterStatusVariant(status) {
            console.log('status', status)
            switch (status) {
                case statuses.INVALID_LOCATION:
                    return 'warning'
                case statuses.ERROR:
                    return 'danger'
                case statuses.COMPLETE:
                    return 'success'
                default:
                    return 'info'
            }
        },
    },

    computed: {
        columnsMap() {
            console.log(
                'this.configurationSettings',
                this.configurationSettings
            )
            const x = { ...this.configurationSettings }
            delete x.rowno
            return x
        },

        tableFields() {
            const _fields = this.fields.map(x => ({
                key: x.name,
                label: this.$translate(x.label),
            }))
            _fields.unshift(
                { key: 'no', label: this.$translate('no'), stickyColumn: true },
                { key: 'status', label: this.$translate('status'), stickyColumn: true }
            )
            return _fields
        },
    },
    watch: {
        value: function (val) {
            this.modalVisible = val
        },
        importList: {
            handler: function (val) {
                if (val.length > 0) {
                    this.loadStatusList()
                }
            },
            deep: true,
        },
    },
    mounted() {
        console.log('location', location.href)
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            console.log('Modal is about to be shown', bvEvent, modalId)
        })
        this.$root.$on('bv::modal::hide', () => {
            this.$emit('input', false)
        })

        this.model = this.fields.reduce((obj, field) => {
            obj[field] = field == 'country' ? 'Jamaica' : ''
            return obj
        }, {})
    },

    methods: {
        /**
         * Where the value for the column index is -1, set the column setting to undefined.
         * @param data The data settings
         */
        preprocessDataSettings(data) {
            var dataCopy = { ...data }
            for (const [key, value] of Object.entries(dataCopy)) {
                dataCopy[key] = value == -1 ? undefined : value
            }
            return dataCopy
        },
        /**
         * Validates the form data based on whether the field is required or not
         * @param data The form data
         * @returns A list of errors if there are any or an empty list if there are none
         */
        validateDataSettings(data) {
            var errors = []
            for (const field of this.fields) {
                if (data[field.name] == undefined && field.required) {
                    errors.push(`${capitalCase(field.name)} ${this.$translate('is_required')}`)
                }
            }
            return errors
        },

        async updateConfiguration(data) {
            try {
                this.submitting = true
                data = this.preprocessDataSettings(data)
                // validate data
                var result = this.validateDataSettings(data)

                // show errors if any
                if (result.length) {
                    for (const err of result) {
                        this.doToast(this.$translate('error'), err, 'danger')
                    }
                    this.doToast(this.$translate('error'), this.$translate('update_setting_failed'), 'danger')
                    // abort update due to errors
                    return
                }

                const text_value = JSON.stringify(data)
                const bool_value = false
                const key = this.settingsKey
                const { settingsKeyName, settingsKey } = this
                console.log({ key, text_value, settingsKeyName, settingsKey })
                await this.$store.dispatch('company/updateConfiguration', {
                    key,
                    text_value,
                    bool_value,
                })

                this.doToast(
                    this.$translate('success'),
                    this.$translate('updated'),
                    'success'
                )
            } catch (err) {
                console.log(err.response.data.error.message)
                this.doToast(
                    this.$translate('error'),
                    `${this.$translate('update_setting_alert')} ${err.response.data.error.message}`,
                    'danger'
                )
            } finally {
                this.submitting = false
            }
        },
        exportSampleFile() {
            this.$refs.uploadDataSettings.exportSampleFile()
        },

        onSubmit(data) {
            console.log('data', data)
        },
        processError(err) {
            console.log('err', err)
        },
        loadStatusList() {
            this.statusList = this.importList.map((x, i) => {
                let status = statuses.PENDING
                let no = i + 1
                return { ...{ no, status, error_list: [] }, ...x }
            })
        },
        checkEntry(record) {
            const emailRegex =
                /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
            //const textRegex = /^[a-zA-Z0-9\s.-]+$/
            const textRegex = /^[ A-Za-z0-9.()_\-$/:@#&,+]*$/ // /^[a-zA-Z0-9-_. ]*$/
            for (const field of this.fields) {
                const value = record[field.name]
                console.log('checking cell', { field, value })

                const fieldName = field.name

                //check if email
                if (field.type == 'email' && value && !emailRegex.test(value)) {
                    console.log('invalid email value', { field, value })
                    return {
                        check: -1,
                        field: fieldName,
                        message: this.$translate('invalid_email_format'),
                    }
                }
                //must be valid text
                if (field.type == 'text' && value && !textRegex.test(value)) {
                    console.log('invalid text value', { field, value })
                    return {
                        check: 0,
                        field: fieldName,
                        message: this.$translate('invalid_value'),
                    }
                }

                //check if required
                if (field.type == 'text' && field.required && !value) {
                    console.log('Field is Required', { field })
                    return {
                        check: 0,
                        field: fieldName,
                        message: this.$translate('field_required'),
                    }
                }
            }
            return { check: 1 }
        },

        previewFiles() { },
        cancel() {
            this.modalVisible=false
            this.importList = []
        },

        async uploadData() {
            const $this = this
            const setLoading = state => {
                $this.submitting = state
            }
            for (let i = 0; i < this.importList.length; i++) {
                const checkResp = this.checkEntry(this.importList[i])
                console.log('check', checkResp)
                await this.uploadRecord(
                    this.importList[i],
                    this.statusList[i],
                    checkResp,
                    statuses,
                    setLoading
                )
            }
            this.doToast(this.$translate('completed'), this.$translate('process_completed'), 'success')
            //this.$emit('success')
            //this.$emit('cancel')
            //this.importList = []
        },
    },
}
</script>

<style></style>
